module.exports = __webpack_public_path__ + "img/stars.f61fb78a.png";